import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ErrorMessage, ModalFormContainer } from '..';
import { IdentityContext } from '../../context';
import { useCreate, useUpdate } from '../../hooks';
import { AuthUserContext } from '../auth-component';
import { ButtonBar, Input } from '../basic-inputs';
  
export function UserInfo() {
  const navigate = useNavigate();
  const { user } = useContext(AuthUserContext);
  const { person, update: updatePerson } = useContext(IdentityContext);

  const [ error, setError ] = React.useState('');

  const { handleUpdate } = useUpdate('people');
  const { handleCreate } = useCreate('people');

  const handleClick = useCallback(async (event) => {
    event.preventDefault();
    const form = event.target.form;
    const data = new FormData(form);

    const payload = {
      first_name: data.get('first-name'),
      middle_name: data.get('middle-name'),
      last_name: data.get('last-name'),
      maiden_name: data.get('maiden-name'),
      linked_user_id: user.id
    };

    if (!payload.first_name) {
      return setError('First name is required');
    }
    if (!payload.last_name) {
      return setError('Last name is required');
    }

    if (!person) {
      await handleCreate(payload);
    } else {
      await handleUpdate(person.id, payload);
    }

    updatePerson();
    navigate('#address');
  }, []);

  // TODO: use person type
  const { firstName, middleName, lastName, maidenName } = person ?? ({} as Record<string, string>);

  return (
    <ModalFormContainer
      icon="person"
      header="Personal Information"
      step={1}
      steps={4}
    >
      <Input id="first-name" type="text" label="First Name" required defaultValue={firstName} />
      <Input id="middle-name" type="text" label="Middle Name" defaultValue={middleName} />
      <Input id="last-name" type="text" label="Last Name" required defaultValue={lastName} />
      <Input
        id="maiden-name"
        type="text"
        label="Maiden Name (if applicable)"
        placeholder="Maiden Name"
        defaultValue={maidenName}
      />
      <ErrorMessage message={error} />
      <ButtonBar
        handlePrimary={handleClick}
        primaryText="Continue"
      />
    </ModalFormContainer>
  );
}

